<div class="manage-compliance">
  <div class="manage_compliance-container">


    <div>
      <h2>Manage Compliance</h2>
      <h4>in 3 easy steps</h4>
  </div>
  <div class="manage-compliance__cards">
      <ng-container *ngFor="let item of sectionCards">
          <div class="manage-compliance__container">
              <img src="{{item?.imagePath}}">
              <div class="manage-compliance__card-title" >{{item?.title}}</div>
              <!-- <div class="manage-compliance__card-description">
                  {{item?.description}}
              </div> -->
          </div>
      </ng-container>
  </div>

</div>
</div>
